// ============================================================
// Mock Fee Structures Data
// ============================================================
// Scoped by schoolId

export const mockFeeStructures = {
  'school-1': [
    {
      id: 'fee-str-1',
      name: 'Tuition Fee',
      category: 'Academic',
      amount: 15000,
      frequency: 'Quarterly',
      dueDate: '5th of respective month',
      description: 'Standard quarterly tuition fee for all classes',
      status: 'active',
      createdAt: '2025-01-10T10:00:00Z',
    },
    {
      id: 'fee-str-2',
      name: 'Admission Fee',
      category: 'Admission',
      amount: 25000,
      frequency: 'One Time',
      dueDate: 'At time of admission',
      description: 'One-time admission charge for new students',
      status: 'active',
      createdAt: '2025-01-10T10:00:00Z',
    },
    {
      id: 'fee-str-3',
      name: 'Transport Fee',
      category: 'Transport',
      amount: 3000,
      frequency: 'Monthly',
      dueDate: '10th of every month',
      description: 'Monthly transport charges',
      status: 'active',
      createdAt: '2025-01-15T10:00:00Z',
    },
    {
      id: 'fee-str-4',
      name: 'Library Fee',
      category: 'Academic',
      amount: 1500,
      frequency: 'Yearly',
      dueDate: 'August 1st',
      description: 'Annual library maintenance and book fund',
      status: 'active',
      createdAt: '2025-02-01T10:00:00Z',
    }
  ],
  'school-002': [
    {
      id: 'fee-str-5',
      name: 'Tuition Fee',
      category: 'Academic',
      amount: 12000,
      frequency: 'Quarterly',
      dueDate: '5th of respective month',
      description: 'Standard quarterly tuition fee',
      status: 'active',
      createdAt: '2025-01-10T10:00:00Z',
    }
  ]
};
